import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import '@vant/touch-emulator';
import { Tabbar, Progress, TabbarItem, Button, Toast, Swipe, SwipeItem, Lazyload, Popup , List , Field ,PullRefresh ,Cell, Form,Checkbox, CheckboxGroup, Dialog ,Icon,ShareSheet,Empty,Stepper,Search} from 'vant';
import './clearCache.js'

Vue.config.productionTip = false
Vue.use(Button).use(Progress).use(PullRefresh).use(Toast).use(Swipe).use(SwipeItem).use(Cell).use(Lazyload).use(Tabbar).use(TabbarItem).use(Popup).use(List).use(Field).use(Form).use(Checkbox).use(CheckboxGroup).use(Dialog).use(Icon).use(ShareSheet).use(Empty).use(Stepper).use(Search);
Vue.component(VueQrcode.name, VueQrcode)

Vue.prototype.langUtil =  (index) => {
  return store.state.language[index][store.state.languagetype];
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
